import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-titulo-descripcion',
  templateUrl: './titulo-descripcion.component.html',
  styleUrls: ['./titulo-descripcion.component.css']
})
export class TituloDescripcionComponent implements OnInit {

  @Input() titulo: string
  @Input() descripcion: string

  ngOnInit(): void {
  }

}
